import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { VolunteerOrgProjectAssignment } from "./entity";

const createCustomFilter =
  createCustomFilterForEntity<VolunteerOrgProjectAssignment>();

export class VolunteerOrgProjectAssignmentFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<VolunteerOrgProjectAssignment>
  >((filters) =>
    filterWithRelationsAndJson(VolunteerOrgProjectAssignment)(filters),
  );
}
